import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ServicesService } from '../../../../services/services.service';
import { map, catchError } from 'rxjs/operators';
import { HttpService } from '../../../../../core/services/http.service';
import { throwError } from 'rxjs';
import { LoadingService } from '../../../../../core/components/loading/loading.service';
import { FlowsService } from '../../../flows.service';
import { AuthorizationSchemeService } from '../../../authorization_scheme.service';

@Injectable({ providedIn: 'root' })
export class FlowResolver  {

  constructor(private flowService: FlowsService,
    private authorizationSchemeService: AuthorizationSchemeService,
    private loadingService: LoadingService,
    private serviceService: ServicesService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    this.loadingService.start();
    const partner = route.paramMap.get('partner');
    const account = route.paramMap.get('account');
    const snapshot_id = route.paramMap.get('snapshot_id');
    const selector_test_id = route.paramMap.get('selector_test_id');
    const flow_id = route.paramMap.get('flow_id');
    const version = route.paramMap.get('version');
    const order = route.paramMap.get('order');
    const start = route.paramMap.get('start');
    const end = route.paramMap.get('end');
    const orders = route.paramMap.get('orders');

    return forkJoin([

      this.flowService.getFlow(partner, account, snapshot_id, selector_test_id, flow_id, version, order, start, end, orders),
      this.serviceService.filter(partner, account, ['A'], false),
      this.authorizationSchemeService.list(partner, account, false),
      this.flowService.getFilterAntifrauds(partner, account, false),
      this.serviceService.filter3ds(partner, account, false),
      this.flowService.getFilter3ds(partner, account, false),
    ])
      .pipe(
        map(result => {
          this.loadingService.stop();
          return {
            flows: result[0],
            fraud_verication: result[1],
            authorization_schemes: result[2],
            variables: result[3],
            threeds: result[4],
            variables_3ds: result[5]
          };
        }),
        catchError((erro) => throwError(erro))
      );
  }
}
